import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Card, CardActions,
  CardBody,
  CardContent,
  CardTitle,
  Typography,
  Radio,
  RadioGroup,
  SelectionControlLabel
} from '@one-thd/sui-atomic-components';
import { TableDataShape } from '../../shapes/TableData';

function TableRow(tableData, setSelected, preferences) {
  const [preference, setPreference] = React.useState(preferences);

  useEffect(() => {
    setPreference(preferences);
  }, [preferences]);

  return (title) => {
    const { subText } = tableData[title];

    const handleChange = (event) => {
      setSelected(event.target.value);
      setPreference(event.target.value);
    };

    function displayRadioButtons(inputAttributes, preferenceInput) {
      return (
        <RadioGroup
          orientation="horizontal"
          aria-labelledby="language-horizontal-radio-buttons-group-label"
          name="horizontal-language-buttons-group"
          style={{
            flexWrap: 'wrap',
          }}
          value={preference}
          onChange={handleChange}
        >
          <SelectionControlLabel value="email" label="Email">
            <Radio
              inputAttributes={preferenceInput}
              id="email"
            />
          </SelectionControlLabel>
          <SelectionControlLabel value="text" label="Text">
            <Radio
              inputAttributes={preferenceInput}
              id="text"
            />
          </SelectionControlLabel>
          <SelectionControlLabel value="both" label="Both Email & Text">
            <Radio
              inputAttributes={preferenceInput}
              id="both"
            />
          </SelectionControlLabel>
        </RadioGroup>
      );
    }

    const inputAttributes = { 'aria-label': `checkbox-${title}` };
    const preferenceInput = { 'aria-label': `radio-button-${title}` };

    return (
      <Card disablePadding>
        <CardContent>
          <CardTitle
            header={(
              <Typography
                variant="h5"
                weight="base"
                height="snug"
                lineClamp="3"
              >
                {title}
              </Typography>
            )}
            key={title}
          />
          <CardBody>
            <Typography variant="body-base">{subText}</Typography>
          </CardBody>
          <CardActions>
            {displayRadioButtons(inputAttributes, preferenceInput)}
          </CardActions>
        </CardContent>
      </Card>
    );
  };
}

function OrderPreferencesCard({
  tableData, setSelected, preferences
}) {
  const tableRow = TableRow(tableData, setSelected, preferences);

  return (
    Object.keys(tableData).map(tableRow)
  );

}

OrderPreferencesCard.propTypes = {
  tableData: TableDataShape.isRequired,
  setSelected: PropTypes.func.isRequired,
  preferences: PropTypes.string.isRequired,
};

export default OrderPreferencesCard;
